module.exports = __webpack_public_path__ + "img/PHF_LOGO_BLACK.9ef2619a.svg";